import { gql } from '../__generated__/gql'

export const ENTERPRISE_PLAN = gql(`
  query EnterprisePlan(
    $enterprisePlanInput: EnterprisePlanInput!
  ) {
    enterprisePlan(input: $enterprisePlanInput) {
      id
      metadata {
        orgName
        type
        planExpirationDate
        planStartDate
        inUseSeats
        type
        ssoConfigs {
          slug
          scope
          orgUrl
          domains
        }
        basicSetupDomains
        promoCodes
        maxSeats
      }
      userSignups {
        total
        userSignups {
          id
          email
          signupDate
          lastUsedDate
        }
      }
      impact {
        timeSaved {
          total
          avgTimeSavedPerUser
        }
        protectionScore {
          numUsersPerBucket {
            bucket
            numUsers
          }
          numUsersPerBucketPerConcernArea {
            concernArea
            bucket
            numUsers
          }
        }
      }
      usage {
        checklistsUsed {
          total
          userChecklistsUsedPerPlatform {
            platform
            num
          }
          percentageOfUsersWithChecklistPerPlatform {
            platform
            num
          }
          percentageOfUsersWithChecklistAnywhere
        }
        contentDeleted {
          total
          userContentDeletedPerPlatform {
            platform
            num
          }
          percentageOfUsersWithContentDeletedPerPlatform {
            platform
            num
          }
          percentageOfUsersWithContentDeletedAnywhere
        }
        connectionsRemoved {
          total
          userConnectionsRemovedPerPlatform {
            platform
            num
          }
          percentageOfUsersWithConnectionsRemovedPerPlatform {
            platform
            num
          }
          percentageOfUsersWithConnectionsRemovedAnywhere
        }
        recommendationsUpdated {
          total
          recommendationsUpdatedPerPlatform {
            platform
            num
          }
          percentageOfUsersWithRecommendationsUpdatedPerPlatform {
            platform
            num
          }
          percentageOfUsersWithRecommendationsUpdatedAnywhere
        }
      }
    }
  }
`)

export const CREATE_BULK_LICENSE = gql(`
  mutation AdminCreateBulkLicenseEnterprisePlan(
    $numberOfLicenses: Int!,
    $orgName: String!,
    $planExpirationDate: String!,
    $planStartDate: String!,
    $stripePromoCode: String!
  ) {
    adminCreateBulkLicenseEnterprisePlan(
      numberOfLicenses: $numberOfLicenses,
      orgName: $orgName,
      planExpirationDate: $planExpirationDate,
      planStartDate: $planStartDate,
      stripePromoCode: $stripePromoCode
    ) {
      statusCode
      error
      stripeCouponId
    }
  }
`)

export const CREATE_BASIC_SETUP = gql(`
  mutation AdminCreateBasicSetupEnterprisePlan(
    $numberOfLicenses: Int,
    $orgName: String!,
    $planExpirationDate: String!,
    $planStartDate: String!,
    $stripePromoCode: String!,
    $domains: [String!]!
  ) {
    adminCreateBasicSetupEnterprisePlan(
      numberOfLicenses: $numberOfLicenses,
      orgName: $orgName,
      planExpirationDate: $planExpirationDate,
      planStartDate: $planStartDate,
      stripePromoCode: $stripePromoCode,
      domains: $domains
    ) {
      statusCode
      error
      stripeCouponId
    }
  }
`)

export const CREATE_SSO = gql(`
  mutation AdminCreateSSOEnterprisePlan(
    $orgName: String!,
    $planExpirationDate: String!,
    $planStartDate: String!,
    $orgUrl: String!,
    $slug: String!,
    $scope: [String!]!,
    $stagingOrgUrl: String,
    $domains: [String!]
  ) {
    adminCreateSsoEnterprisePlan(
      orgName: $orgName,
      planExpirationDate: $planExpirationDate,
      planStartDate: $planStartDate,
      orgUrl: $orgUrl,
      slug: $slug,
      scope: $scope,
      stagingOrgUrl: $stagingOrgUrl,
      domains: $domains
    ) {
      enterprisePlanId
    }
  }
`)

export const UPGRADE_TO_SSO = gql(`
  mutation AdminUpgradeToSSOEnterprisePlan(
    $enterprisePlanId: Int!,
    $orgUrl: String!,
    $slug: String!,
    $scope: [String!]!,
    $stagingOrgUrl: String!,
    $additionalDomains: [String!]
  ) {
    adminUpgradeToSsoEnterprisePlan(
      enterprisePlanId: $enterprisePlanId,
      orgUrl: $orgUrl,
      slug: $slug,
      scope: $scope,
      stagingOrgUrl: $stagingOrgUrl,
      additionalDomains: $additionalDomains
    ) {
      enterprisePlanId
    }
  }
`)

export const UPGRADE_TO_BASIC_SETUP = gql(`
  mutation AdminUpgradeToBasicSetupEnterprisePlan(
    $enterprisePlanId: Int!,
    $domains: [String!]!
  ) {
    adminUpgradeToBasicSetupEnterprisePlan(
      enterprisePlanId: $enterprisePlanId,
      domains: $domains
    ) {
      enterprisePlanId
    }
  }
`)

export const UPDATE_ENTERPRISE_PLAN_EXPIRATION_DATE = gql(`
  mutation AdminUpdateEnterprisePlanExpirationDate(
    $enterprisePlanId: Int!,
    $planExpirationDate: String!
  ) {
    adminUpdateEnterprisePlanExpirationDate(
      enterprisePlanId: $enterprisePlanId,
      planExpirationDate: $planExpirationDate
    ) {
      statusCode
      error
      planExpirationDate
    }
  }
`)
